import React from "react"
import { Portfolio } from "../components/portfolio"


export const PortfolioPage: React.FC = () =>{
  return (
    <div className="page">
      <Portfolio/>
    </div>

    )
}